import { PREFERENCE_ANALYSIS_TABS } from '../../../../../../utils/routes';
import { defaultTheme } from '../../../../../../utils/defaultTheme';
export const SECTION_IDS = {
    AWARENESS: 1,
    CONSIDERATION: 2,
    AD_RECALL: 1,
};

export const AXA_AND_AXABRANDS_ID = 50;

export const SECTION_TYPES = {
    TABLE: 'Table',
    KPI: 'KPI',
    BENCHMARK: 'Benchmark',
};

export const VALUE_TYPES = {
    TYPE_AVERAGE: 'average',
};

export const CUSTOM_LINECHART_WIDTH_PAGE_FLAG = {
    IMAGE: 'Image',
    ADRECALL: 'AdRecall',
    ADCOMPARISON: 'AdComparison',
};

export const PAGES_NEED_SEPARATE_LOBS_LEGENDS = [
    PREFERENCE_ANALYSIS_TABS.TAB_ITEMS.AWARENESS.path,
    PREFERENCE_ANALYSIS_TABS.TAB_ITEMS.AD_RECALL.path,
    PREFERENCE_ANALYSIS_TABS.TAB_ITEMS.CONSIDERATION.path,
    PREFERENCE_ANALYSIS_TABS.TAB_ITEMS.IMAGE.path,
];

export const STORE_NAME_ROUTE_BASED = {
    [PREFERENCE_ANALYSIS_TABS.TAB_ITEMS.AWARENESS.path]: 'awarenessData',
    [PREFERENCE_ANALYSIS_TABS.TAB_ITEMS.CONSIDERATION.path]: 'considerationData',
    [PREFERENCE_ANALYSIS_TABS.TAB_ITEMS.AD_RECALL.path]: 'adRecallData',
    [PREFERENCE_ANALYSIS_TABS.TAB_ITEMS.VALUE_FOR_MONEY.path]: 'valueForMoneyData',
    [PREFERENCE_ANALYSIS_TABS.TAB_ITEMS.IMAGE.path]: 'imageData',
};

export const sectionsHeadColor = {
    backgroundColor: defaultTheme.violet[100],
    color: defaultTheme.violet[500],
};

export const METRICS_VALUE_COLORS_MAP = {
    1: {
        border: defaultTheme.green[300],
        background: defaultTheme.green[60],
        textColor: defaultTheme.green[500],
    },
    '-1': {
        border: defaultTheme.red[350],
        background: defaultTheme.red[70],
        textColor: defaultTheme.red[600],
    },
    0: {
        border: defaultTheme.blue[70],
        background: defaultTheme.grey[50],
        textColor: defaultTheme.blue[900],
    },
};
export const numFormatterExceptZero = number => {
    if (!Number.isFinite(number)) return null;
    return number === 0
        ? number
        : new Intl.NumberFormat('en-GB', { style: 'decimal', signDisplay: 'always' }).format(number);
};

export const brandsObjectProcessing = brands => {
    const brandsNewStructure = brands.map(i => {
        return {
            key: i.brandId,
            itemLabel: i.brandName,
            color: i.color,
            isChecked: i.isMainBrand,
            isDefaultChecked: i.isMainBrand,
        };
    });
    const sortedBrands = brandsNewStructure
        .filter(e => e.isDefaultChecked)
        .concat(
            brandsNewStructure.filter(e => !e.isDefaultChecked).sort((a, b) => a.itemLabel.localeCompare(b.itemLabel))
        );
    return sortedBrands;
};

export const CHART_ITEM_TYPES = {
    BAR: 'main',
    LINE: 'line',
    MARKET_AVERAGE: 'dottedline',
};

export const SECTION_DATA_TYPE = {
    DEFAULT: 'sections',
    EVOLUTION: 'sectionsEvolutionReport',
};

//isEvolutionReport - data processing for the custom tooltip for CombinedBarLinechart
export function generateTooltipDataByGroup(data, visibleLOBs) {
    const groups = data.barData.values.map(v => v.group);

    const barValuesMap = new Map(data.barData.values.map(v => [v.group, v.value]));

    const lineDataMap = data.lineData.map(line => ({
        name: line.name,
        color: line.color,
        isDottedLine: line.itemType === CHART_ITEM_TYPES.MARKET_AVERAGE,
        valuesMap: new Map(line.values.map(v => [v.group, v.value])),
    }));

    const tooltipDataByGroup = {};

    groups.forEach(group => {
        const entries = [];

        const barValue = barValuesMap.get(group);
        entries.push({
            name: data.barData.name,
            color: data.barData.color,
            score: `${barValue}%`,
            rawScore: barValue,
            isMainBrand: true, //bar value should always have isMainBrand true
        });

        lineDataMap.forEach(line => {
            const value = line.valuesMap.get(group);
            entries.push({
                name: line.name,
                color: line.color,
                isDottedLine: line.isDottedLine,
                score: value ? `${value}%` : '-',
                rawScore: value,
                isMainBrand: false,
            });
        });

        const ranked = [...entries]
            .filter(entry => !entry.isDottedLine)
            .sort((a, b) => {
                if (a.rawScore === undefined && b.rawScore === undefined) return 0;
                if (a.rawScore === undefined) return 1;
                if (b.rawScore === undefined) return -1;
                return b.rawScore - a.rawScore;
            })
            .map((entry, index, arr) => {
                // Competition ranking logic
                if (index === 0) {
                    entry.rank = 1;
                } else if (entry.rawScore === arr[index - 1].rawScore) {
                    entry.rank = arr[index - 1].rank;
                } else {
                    // Find how many previous entries had the same rank
                    const prevRank = arr[index - 1].rank;
                    const prevCount = arr.slice(0, index).filter(e => e.rank === prevRank).length;
                    entry.rank = prevRank + prevCount;
                }
                return {
                    ...entry,
                    rank: entry.rank.toString(),
                };
            });
        const visibleLobsRanked = ranked.filter(item => visibleLOBs.includes(item.name));

        const sortedBrands = visibleLobsRanked
            .sort((a, b) => {
                if (a.isMainBrand) return -1;
                if (b.isMainBrand) return 1;
                return a.name.localeCompare(b.name);
            })
            .concat([...entries].filter(entry => entry.isDottedLine));
        //sort decending by rank and keep main brand first
        tooltipDataByGroup[group] = sortedBrands
            .map(({ rawScore, ...rest }) => rest)
            .sort((a, b) => {
                if (a.isMainBrand && !b.isMainBrand) return -1;
                if (!a.isMainBrand && b.isMainBrand) return 1;
                return a.rank - b.rank;
            });
    });
    return tooltipDataByGroup;
}

export const checkedBrandsEvolutionExportFormat = brandsArray => {
    const checkedBrands = brandsArray
        .filter(item => item.isChecked)
        .map(item => ({
            brandId: item.key,
            brandName: item.itemLabel,
            color: item.color,
            isMainBrand: item.isDefaultChecked,
        }));
    return checkedBrands;
};

export const resetBrandsListLOBLegendObject = (brandsArray, setBrandsArray) => {
    return {
        hasNoBrandsSelected: !brandsArray.filter(brand => !brand.isDefaultChecked).some(brand => brand.isChecked),
        mainBrands: brandsArray
            .filter(brand => brand.isDefaultChecked)
            .map(brand => brand.itemLabel)
            .join(','),
        onReset: () =>
            setBrandsArray(
                brandsArray.map(brand => ({
                    ...brand,
                    isChecked: brand.isDefaultChecked,
                }))
            ),
    };
};
